import _ from "lodash";
import {
  CURRICULUM_TYPE_PYP,
  COURSE_BASED_GRADING,
} from "Constants/stringConstants";
import { USE_NEW_GRADING_SETUP_IN_COURSE_PERM } from "Constants/permissionConstants";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import { getAcademicSetupType } from "Teacher/routes/LearningCourses/modules/Utils";
import { store } from "store/createStore";
import { TEMPLATE_VERSION_3_0 } from "./constants";

export const getReportSetTemplateVersion = () =>
  _.get(store.getState(), "progressReport.reportTemplateProps.version", null);

export const getReportTemplateVersion = () =>
  _.get(store.getState(), "progressReportTemplate.template.body.version", null);

// Template version constants

export const getValueBasedOnReportType = ({
  courseValue = true,
  subjectValue = true,
  defaultValue = null,
} = {}) => {
  const templateVersion =
    getReportSetTemplateVersion() || getReportTemplateVersion();

  const academicSetupType = getAcademicSetupType();
  const isNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
  });

  if (templateVersion && templateVersion !== TEMPLATE_VERSION_3_0) {
    // For template versions other than 3.0, always return defaultValue
    return defaultValue;
  }

  if (isNewGradingSetupInCourses) {
    return academicSetupType === COURSE_BASED_GRADING
      ? courseValue
      : subjectValue;
  }
  return defaultValue;
};

export const isPypVersion1 = ({ curriculumType }) =>
  curriculumType == CURRICULUM_TYPE_PYP &&
  !getValueBasedOnReportType({
    defaultValue: false,
  });

export const getIsMultiTermReport = ({ gradingPeriodType = "REPORTING" }) =>
  gradingPeriodType == "CUMULATIVE";

export const getCompactSections = ({ curriculumType }) => {
  const compactSections = {
    nodeIds: ["sheet", "ps", "attendance"],
    filterOptions: { isCustomPage: true },
  };
  if (curriculumType === CURRICULUM_TYPE_PYP) {
    compactSections["nodeIds"] = ["sheet", "psSummary", "attendance"];
  }
  return compactSections;
};
